@if (isFormReady) {
    <div class="form-container" id="formContainer">
        <div class="container-full-height">
            @if (!formCommonDataService.isInternal) {
                <header class="header position-relative">
                    @if (form.logoLink && !form.hideLogo) {
                        <div>
                            @if (form.options.customerWebsiteLink) {
                                <a target="_blank" [href]="form.options.customerWebsiteLink">
                                    <img alt="Website link" class="logo mb-2 mt-2" [src]="form.logoLink" />
                                </a>
                            } @else {
                                <img alt="" class="logo mb-2 mt-2" [src]="form.logoLink" />
                            }
                        </div>
                    }

                    @if (form.bigLogoLink && !form.hideBigLogo) {
                        <div class="banner-container">
                            <img alt="" class="banner" [src]="form.bigLogoLink" />
                        </div>
                    }
                </header>
            }
            <main class="container mb-2">
                @if (step === formStepEnum.fillingForm) {
                    <form
                        #ticketForm="ngForm"
                        id="newTicketForm"
                        appCheckFormInit
                        [ngForm]="ticketForm"
                        (ngSubmit)="isSaving || send()"
                        class="form container form-fields-with-rules"
                        [ngClass]="{ 'form-submitted': formService.isSubmitted }"
                        [attr.aria-label]="'Contact form' | translate">
                        @for (formField of form.fields; track formField) {
                            <sb-form-field
                                [class.highlighted]="formField.isDependant && formField.isShowedBecauseOfRule"
                                [formField]="formField"
                                [formType]="form.type"
                                appCheckFieldRules
                                [field]="formField"
                                [fields]="form.fields"
                                [formLanguage]="form.language">
                            </sb-form-field>
                        }

                        @if (isReCaptchaEnabled) {
                            <sb-recaptcha [key]="'6Lczq_4SAAAAAINDHul2B3KIm0Lt9fMg0IxK3kA-'" [lang]="reCaptchaLanguage">
                            </sb-recaptcha>
                        }

                        <div class="mt-4 clearfix buttons-wrapper">
                            @if (formCommonDataService.isFromFaq && formCommonDataService.backUrl) {
                                <a
                                    class="btn-link float-start me-3"
                                    style="margin-top: 7px"
                                    href="{{ formCommonDataService.backUrl || form.faqLink }}">
                                    {{ 'Back to FAQ' | translate }}
                                </a>
                            }

                            @if (!formCommonDataService.isInternal) {
                                <button
                                    class="btn btn-primary float-end"
                                    [disabled]="isSaving || isUploadingFiles"
                                    type="submit">
                                    {{ 'Send' | translate }}
                                </button>
                            } @else {
                                <label
                                    class="checkbox__label me-3 mb-3"
                                    for="isCreateAnotherTicket"
                                    style="margin-top: 9px">
                                    {{ 'Create another ticket' | translate }}
                                    <input
                                        type="checkbox"
                                        id="isCreateAnotherTicket"
                                        name="isCreateAnotherTicket"
                                        [(ngModel)]="isCreateAnotherTicket" />
                                    <span class="checkbox__checkmark"></span>
                                </label>
                                <label class="checkbox__label me-4 mb-3" for="isAssignedToCreator">
                                    {{ 'Assign to me' | translate }}
                                    <input
                                        type="checkbox"
                                        id="isAssignedToCreator"
                                        name="isAssignedToCreator"
                                        [(ngModel)]="isAssignedToCreator" />
                                    <span class="checkbox__checkmark"></span>
                                </label>

                                <div class="float-end">
                                    @if (!commonDataService.customerSettings?.isCustomerReplyPortalEnabled) {
                                        <button
                                            class="btn btn-primary float-end ms-2 mb-2"
                                            [disabled]="isSaving || isLoading || isUploadingFiles"
                                            type="submit"
                                            (click)="prepareTicketCreation(true)">
                                            {{ 'Create and close' | translate }}
                                        </button>
                                        <button
                                            class="btn btn-primary float-end"
                                            [disabled]="isSaving || isUploadingFiles"
                                            (click)="prepareTicketCreation(false)"
                                            type="submit">
                                            {{ 'Create' | translate }}
                                        </button>
                                    } @else {
                                        <div
                                            dropdown
                                            class="btn-group float-end"
                                            [isDisabled]="isSaving || isUploadingFiles"
                                            [dropup]="true">
                                            <button
                                                class="btn btn-primary"
                                                [disabled]="isSaving || isUploadingFiles"
                                                (click)="prepareTicketCreation(false)"
                                                type="submit">
                                                {{ 'Create' | translate }}
                                            </button>
                                            <button
                                                dropdownToggle
                                                type="button"
                                                class="btn btn-primary dropdown-toggle dropdown-toggle-split"></button>

                                            <ul
                                                *dropdownMenu
                                                class="dropdown-menu dropdown-menu-right reply-link-block">
                                                <li>
                                                    <button
                                                        class="btn icon-padding"
                                                        type="submit"
                                                        (click)="prepareTicketCreation(true)">
                                                        {{ 'Create and close' | translate }}
                                                    </button>
                                                </li>
                                                <li>
                                                    <button
                                                        class="btn reply-link"
                                                        type="submit"
                                                        (click)="prepareTicketCreation(false, true)">
                                                        <sb-inline-svg
                                                            class="icon ps-0"
                                                            aria-label="Link icon"
                                                            [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Link icon 2.svg'">
                                                        </sb-inline-svg>
                                                        <span>{{ 'Create with reply-link' | translate }}</span>
                                                    </button>
                                                </li>
                                                <li>
                                                    <button
                                                        class="btn reply-link"
                                                        type="submit"
                                                        [disabled]="isLoading"
                                                        (click)="prepareTicketCreation(true, true)">
                                                        <sb-inline-svg
                                                            class="icon ps-0"
                                                            aria-label="Link icon"
                                                            [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Link icon 2.svg'">
                                                        </sb-inline-svg>
                                                        <span>{{
                                                            'Create with reply-link and close' | translate
                                                        }}</span>
                                                    </button>
                                                </li>
                                            </ul>
                                        </div>
                                    }
                                </div>
                            }
                        </div>
                    </form>
                }
                @if (step === formStepEnum.formSentMessage) {
                    @if (form.type !== formTypeEnum.survey) {
                        <div class="form container">
                            <div class="form-success-wrapper text-break">
                                @if (form.formSentMessage) {
                                    <h1 [innerHTML]="form.formSentMessage | safeHtml"></h1>
                                }
                            </div>

                            <div
                                class="d-flex justify-content-end buttons-wrapper"
                                [ngClass]="{ 'justify-content-center': !form.formSentMessage }">
                                <button
                                    class="btn btn-primary white-space-normal text-break mw-100"
                                    (click)="!form.options.backButtonLink ? backToForm() : true">
                                    @if (form.options.backButtonLink) {
                                        <a class="text-white" [href]="form.options.backButtonLink">
                                            {{ form.options.backButtonText || ('Back to form' | translate) }}
                                        </a>
                                    } @else {
                                        <span>
                                            {{ form.options.backButtonText || ('Back to form' | translate) }}
                                        </span>
                                    }
                                </button>
                            </div>
                        </div>
                    } @else {
                        <div class="form container">
                            <div class="form-success-wrapper text-break">
                                <h1>{{ 'Thank you for your feedback!' | translate }}</h1>
                            </div>
                        </div>
                    }
                }
            </main>
        </div>

        @if (form.options.hideFooter !== 'true' && !formCommonDataService.isInternal) {
            <sb-footer [communityName]="formCommonDataService.community" [configuration]="form" [isForm]="true">
            </sb-footer>
        }

        @if (!form.isCookieMessageHidden && !formCommonDataService.isInternal) {
            <sb-cookie-law-banner></sb-cookie-law-banner>
        }
    </div>
}

@if (formCommonDataService.isSurveySent) {
    <div class="form container" style="max-width: 900px">
        <div class="form-success-wrapper text-break">
            <h1>{{ 'Survey has already been submitted.' | translate }}</h1>
        </div>
    </div>
}
